module.exports = __webpack_public_path__ + "image/Percheron_2.png";